import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { JobOffer } from './joboffer';
import { Observable, of } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import * as jwt_decode from 'jwt-decode';
import { Router } from '@angular/router';

@Injectable()
export class DataService {

    constructor(private http: HttpClient, private router: Router) {
        if (localStorage) {
            // Store data
            this.setAccessToken(localStorage.getItem("access_token"));
            this.setRefreshToken(localStorage.getItem("refresh_token"));
        }
    }

    private access_token: string = "";
    private refresh_token: string = "";
    private tokenData = {};

    public jobOffers: JobOffer[] = [];
    public jobOffer: JobOffer = null;

    loadJobOffers(): Observable<boolean> {
        return this.http.get("/api/JobOffers", this.DefaultHeaders())
            .pipe(
                map((data: JobOffer[]) => {
                    this.jobOffers = data;
                    return true;
                })
            );
    }

    loadJobOffer(id: any): Observable<boolean> {
        return this.http.get("/api/joboffers/" + id, this.DefaultHeaders())
            .pipe(
                map((data: JobOffer) => {
                    if (data) {
                        this.jobOffer = data;
                        return true;
                    }
                    return false;
                })
            );
    }

    saveJobOffer(item: any): Observable<ICustomResult> {
        if (item.id && item.id > 0) {
            return this.http.put("/api/joboffers/" + item.id, item, this.DefaultHeaders())
                .pipe(
                    map((data: JobOffer) => {
                        if (data) {
                            this.jobOffer = data;
                            return { success: true, message: "De vacature is succesvol opgeslagen."};
                        }
                        return { success: false, message: 'Het is niet gelukt het item op te slaan. Neem contact op met de administrator.' };
                    }),
                    catchError((error, caught) => {
                        return of({ success:false, message: error.error || error.message });
                    })
                );
        } else {
            return this.http.post("/api/joboffers", item, this.DefaultHeaders())
                .pipe(
                    map((data: JobOffer) => {
                        if (data) {
                            this.jobOffer = data;
                            return { success: true, message: "De vacature is succesvol opgeslagen." };;
                        }
                        return { success: false, message: 'Het is niet gelukt het item op te slaan. Neem contact op met de administrator.' };
                    }),
                    catchError((error, caught) => {
                        return of({ success: false, message: error.error || error.message });
                    })
                );
        }
    }

    deleteJobOffer(id: any): Observable<ICustomResult> {
        if (id && id > 0) {
            return this.http.delete("/api/joboffers/" + id, this.DefaultHeaders())
                .pipe(
                    map((data: any) => {
                        //console.log(data);
                        return { success: true, message: data.data };
                    }),
                    catchError((error, caught) => {
                        return of({ success: false, message: (error.error || error.message) });
                    })
                );
        }
        return of({ success: false, message: "Ongeldig id opgegeven..." });
    }

    private DefaultHeaders() {
        return {
            headers: new HttpHeaders().set("Authorization", "Bearer " + this.access_token)
        };
    }

    public isAuthenticated(): Observable<boolean> {
        if (!this.isTokenValid()) {
            if (this.refresh_token.length > 0) {
                return this.refreshTokens()
                    .pipe(
                        map(response => {
                            if (response) {
                                console.log('The access token has been refreshed');
                                return true;
                            }
                        }),
                        catchError((error, caught) => {
                            console.log('The access token could not be refreshed');
                            console.log(error);
                            return of(false);
                        })
                    );
            } else {
                return of(false);
            }
        }
        return of(true);
    }

    public setToken(result: any) {
        this.setAccessToken(result.access_token);
        this.setRefreshToken(result.refresh_token);
    }

    public setAccessToken(token: string) {
        this.access_token = token || "";
        if (this.access_token.length > 0) {
            this.tokenData = jwt_decode(this.access_token);
            //console.log(this.tokenData);
        } else {
            this.tokenData = {};
            //console.log("empty token data");
        }
        localStorage.setItem("access_token", this.access_token || "");
    }

    public setRefreshToken(token: string) {
        this.refresh_token = token || "";
        localStorage.setItem("refresh_token", this.refresh_token || "");
    }

    public getAccessToken() {
        return this.access_token;
    }
    public getRefreshToken() {
        return this.refresh_token;
    }

    public isTokenValid() {
        if (this.access_token.length == 0) {
            return false;
        }
        if (this.refresh_token.length == 0) {
            return false;
        }
        const now = Date.now().valueOf() / 1000;
        let decoded: any = this.tokenData;
        if (typeof decoded.exp !== 'undefined' && decoded.exp < now) {
            return false;
        }
        if (typeof decoded.nbf !== 'undefined' && decoded.nbf > now) {
            return false;
        }

        return true;
    }

    public login(creds): Observable<boolean> {
        return this.http
            .post("/account/createtoken", creds)
            .pipe(
                map((data: any) => {
                    this.setToken(data);
                    return true;
                })
            );
    }

    public refreshTokens(): Observable<boolean> {
        return this.http
            .post("/account/refreshtoken", { token: this.refresh_token })
            .pipe(
                tap((data: any) => {
                    this.setToken(data);
                    return true;
                }),
                catchError(error => {
                    this.logout();
                    return of(false)
                })
            );
    }

    public logout() {
        this.setAccessToken("");
        this.setRefreshToken("");
        this.router.navigate(['login']);
    }
}

interface ICustomResult {
    success: boolean;
    message: string;
}